/**
 * Role utility helpers — replaces duplicated inline IIFEs in App.js
 */

export function getUserRoles(user) {
  if (!user) return [];
  const r = user.role ? String(user.role).toLowerCase() : undefined;
  const rs = Array.isArray(user.roles)
    ? user.roles.map(x => String(x).toLowerCase())
    : r ? [r] : [];
  return rs;
}

export function isAdmin(user) {
  return getUserRoles(user).includes('admin');
}

export function isParent(user) {
  return getUserRoles(user).includes('parent');
}

export function isStudent(user) {
  return getUserRoles(user).includes('student');
}

export function hasRole(user, role) {
  return getUserRoles(user).includes(String(role).toLowerCase());
}
